
import React from 'react';
import styled from 'styled-components';

const timelinePhases = [
  { title: 'Phase 1', description: 'Beta testing at 3-5 partner schools' },
  { title: 'Phase 2', description: 'Clinical validation & outcome measurement' },
  { title: 'Phase 3', description: 'State-wide and national scaling' },
];

const Impact = () => {
  return (
    <ImpactSection id="impact">
      <Container>
        <SectionHeading>Ready for Scale - Implementation Roadmap</SectionHeading>
        <Timeline>
          {timelinePhases.map((phase, index) => (
            <TimelineItem key={index}>
              <TimelineDot />
              <TimelineContent>
                <TimelineTitle>{phase.title}</TimelineTitle>
                <p>{phase.description}</p>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
        <ImpactMetrics>
          <h3>Impact Metrics:</h3>
          <p>Built-in tracking for engagement, wellness outcomes, and crisis interventions.</p>
        </ImpactMetrics>
      </Container>
    </ImpactSection>
  );
};

export default Impact;

const ImpactSection = styled.section`
  background-color: var(--background-light);
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const SectionHeading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 5rem;
  color: var(--primary-blue-dark);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Timeline = styled.div`
  position: relative;
  max-width: 800px;
  margin: 0 auto 4rem auto;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    background-color: #e9ecef;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 2rem;

    &::after {
      width: 4px;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const TimelineItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 30%;
  z-index: 2;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: row;
    text-align: left;
  }
`;

const TimelineDot = styled.div`
  width: 24px;
  height: 24px;
  background-color: var(--background-light);
  border: 4px solid var(--primary-blue-light);
  border-radius: 50%;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    margin-bottom: 0;
    margin-right: 1rem;
    flex-shrink: 0;
  }
`;

const TimelineContent = styled.div`
  background: var(--background-dark);
  padding: 1rem;
  border-radius: 8px;
`;

const TimelineTitle = styled.h3`
  font-size: 1.2rem;
  color: var(--primary-blue-dark);
  margin: 0 0 0.5rem 0;
`;

const ImpactMetrics = styled.div`
  background: var(--background-dark);
  padding: 2rem;
  border-radius: 10px;
  display: inline-block;

  h3 {
    margin: 0 0 0.5rem 0;
    color: var(--primary-blue-dark);
  }
`;
